
export const ProjectsIcon = (props: React.SVGProps<SVGSVGElement>) => {
  props = {
    ...props,
    color: props.color,
  };
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14.4 0H1.6C0.8 0 0 0.72 0 1.6V4.008C0 4.584 0.344 5.08 0.8 5.36V14.4C0.8 15.28 1.68 16 2.4 16H13.6C14.32 16 15.2 15.28 15.2 14.4V5.36C15.656 5.08 16 4.584 16 4.008V1.6C16 0.72 15.2 0 14.4 0ZM10.4 9.6H5.6V8H10.4V9.6ZM14.4 4H1.6V1.6H14.4V4Z"
        fill="currentColor"
      />
    </svg>
  );
};
